import { render, staticRenderFns } from "./PassportModal.vue?vue&type=template&id=1e235f03&scoped=true"
import script from "./PassportModal.vue?vue&type=script&lang=js"
export * from "./PassportModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e235f03",
  null
  
)

export default component.exports